"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var index_1 = require("../../src/ontodia/index");
var OWL_PREFIX = 'http://www.w3.org/2002/07/owl#';
var RDFS_PREFIX = 'http://www.w3.org/2000/01/rdf-schema#';
var owl = {
    class: OWL_PREFIX + 'Class',
    objectProperty: OWL_PREFIX + 'ObjectProperty',
    domain: OWL_PREFIX + 'domain',
    range: OWL_PREFIX + 'range',
};
var rdfs = {
    subClassOf: RDFS_PREFIX + 'subClassOf',
    subPropertyOf: RDFS_PREFIX + 'subPropertyOf',
};
function hasType(model, type) {
    return Boolean(model.types.find(function (t) { return t === type; }));
}
var SIMULATED_DELAY = 500; /* ms */
var ExampleMetadataApi = /** @class */ (function () {
    function ExampleMetadataApi() {
    }
    ExampleMetadataApi.prototype.canDropOnCanvas = function (source, ct) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var elementTypes;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, delay(SIMULATED_DELAY, ct)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.typesOfElementsDraggedFrom(source, ct)];
                    case 2:
                        elementTypes = _a.sent();
                        index_1.CancellationToken.throwIfAborted(ct);
                        return [2 /*return*/, elementTypes.length > 0];
                }
            });
        });
    };
    ExampleMetadataApi.prototype.canDropOnElement = function (source, target, ct) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var linkTypes;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, delay(SIMULATED_DELAY, ct)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.possibleLinkTypes(source, target, ct)];
                    case 2:
                        linkTypes = _a.sent();
                        index_1.CancellationToken.throwIfAborted(ct);
                        return [2 /*return*/, linkTypes.length > 0];
                }
            });
        });
    };
    ExampleMetadataApi.prototype.possibleLinkTypes = function (source, target, ct) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            function mapLinkTypes(types, direction) {
                if (direction === void 0) { direction = index_1.LinkDirection.out; }
                return types.map(function (linkTypeIri) { return ({ linkTypeIri: linkTypeIri, direction: direction }); });
            }
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, delay(SIMULATED_DELAY, ct)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, (hasType(source, owl.class) && hasType(target, owl.class) ?
                                mapLinkTypes([rdfs.subClassOf]).concat(mapLinkTypes([rdfs.subClassOf], index_1.LinkDirection.in)) :
                                hasType(source, owl.objectProperty) && hasType(target, owl.class) ?
                                    mapLinkTypes([owl.domain, owl.range]) :
                                    hasType(target, owl.objectProperty) && hasType(source, owl.class) ?
                                        mapLinkTypes([owl.domain, owl.range], index_1.LinkDirection.in) :
                                        hasType(source, owl.objectProperty) && hasType(target, owl.objectProperty) ?
                                            mapLinkTypes([rdfs.subPropertyOf]).concat(mapLinkTypes([rdfs.subPropertyOf], index_1.LinkDirection.in)) :
                                            [])];
                }
            });
        });
    };
    ExampleMetadataApi.prototype.typesOfElementsDraggedFrom = function (source, ct) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, delay(SIMULATED_DELAY, ct)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, (hasType(source, owl.class) ? [owl.class] :
                                hasType(source, owl.objectProperty) ? [owl.class, owl.objectProperty] :
                                    [])];
                }
            });
        });
    };
    ExampleMetadataApi.prototype.propertiesForType = function (type, ct) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, delay(SIMULATED_DELAY, ct)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, []];
                }
            });
        });
    };
    ExampleMetadataApi.prototype.canDeleteElement = function (element, ct) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, delay(SIMULATED_DELAY, ct)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, true];
                }
            });
        });
    };
    ExampleMetadataApi.prototype.filterConstructibleTypes = function (types, ct) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, delay(SIMULATED_DELAY, ct)];
                    case 1:
                        _a.sent();
                        result = new Set();
                        types.forEach(function (type) {
                            if (type.length % 2 === 0) {
                                result.add(type);
                            }
                        });
                        return [2 /*return*/, result];
                }
            });
        });
    };
    ExampleMetadataApi.prototype.canEditElement = function (element, ct) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, delay(SIMULATED_DELAY, ct)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, true];
                }
            });
        });
    };
    ExampleMetadataApi.prototype.canLinkElement = function (element, ct) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, delay(SIMULATED_DELAY, ct)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, true];
                }
            });
        });
    };
    ExampleMetadataApi.prototype.canDeleteLink = function (link, source, target, ct) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, delay(SIMULATED_DELAY, ct)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, true];
                }
            });
        });
    };
    ExampleMetadataApi.prototype.canEditLink = function (link, source, target, ct) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, delay(SIMULATED_DELAY, ct)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, true];
                }
            });
        });
    };
    ExampleMetadataApi.prototype.generateNewElement = function (types, ct) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var random32BitDigits;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, delay(SIMULATED_DELAY, ct)];
                    case 1:
                        _a.sent();
                        random32BitDigits = Math.floor((1 + Math.random()) * 0x100000000).toString(16).substring(1);
                        return [2 /*return*/, {
                                id: types[0] + "_" + random32BitDigits,
                                types: tslib_1.__spreadArrays(types),
                                label: { values: [{ value: 'New Entity', language: '' }] },
                                properties: {},
                            }];
                }
            });
        });
    };
    return ExampleMetadataApi;
}());
exports.ExampleMetadataApi = ExampleMetadataApi;
var ExampleValidationApi = /** @class */ (function () {
    function ExampleValidationApi() {
    }
    ExampleValidationApi.prototype.validate = function (event) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var errors;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        errors = [];
                        if (event.target.types.indexOf(owl.class) >= 0) {
                            event.state.links.forEach(function (e) {
                                if (!e.before && e.after.sourceId === event.target.id) {
                                    errors.push({
                                        type: 'link',
                                        target: e.after,
                                        message: 'Cannot add any new link from a Class',
                                    });
                                    var linkType = event.model.createLinkType(e.after.linkTypeId);
                                    errors.push({
                                        type: 'element',
                                        target: event.target.id,
                                        message: "Cannot create <" + linkType.id + "> link from a Class",
                                    });
                                }
                            });
                        }
                        return [4 /*yield*/, delay(SIMULATED_DELAY, event.cancellation)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, errors];
                }
            });
        });
    };
    return ExampleValidationApi;
}());
exports.ExampleValidationApi = ExampleValidationApi;
function delay(amountMs, ct) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    index_1.CancellationToken.throwIfAborted(ct);
                    return [4 /*yield*/, waitTimeout(amountMs)];
                case 1:
                    _a.sent();
                    index_1.CancellationToken.throwIfAborted(ct);
                    return [2 /*return*/];
            }
        });
    });
}
function waitTimeout(amountMs) {
    if (amountMs === 0) {
        return Promise.resolve();
    }
    return new Promise(function (resolve) { return setTimeout(resolve, amountMs); });
}
